<div class="w-full bg-white">
    <div class="not-found-container">
        <div
            class="mx-auto flex min-h-[60vh] max-w-[600px] flex-col items-center justify-center px-4 py-8"
        >
            <!-- 404 Title -->
            <h1 class="mb-4 text-6xl font-bold text-gray-400">404</h1>

            <!-- Message -->
            <div
                class="text-secondary mt-2 text-center text-lg font-medium tracking-tight text-gray-600 md:text-xl"
            >
                Nous sommes désolés, mais l'article ou la page que vous
                recherchez n'existe pas ou le lien est incorrect.
            </div>
            <button
            [routerLink]="['/']"
            class="mt-12 max w-50 p-2 rounded-lg font-medium bg-primary-500 text-[white]">
         
                Revenir à la page d'acceuil
        </button>
        </div>
    </div>
    </div>